import { Action } from 'redux';

export enum ActionTypes {
    FETCH_START = '@@checkoutsStripeAccount/FETCH_START',
    FETCH_SUCCESS = '@@checkoutsStripeAccount/FETCH_SUCCESS',
    FETCH_ERROR = '@@checkoutsStripeAccount/FETCH_ERROR',
    UPDATE_START = '@@checkoutsStripeAccount/UPDATE_START',
    UPDATE_SUCCESS = '@@checkoutsStripeAccount/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@checkoutsStripeAccount/UPDATE_ERROR',
}

export interface CheckoutsStripeAccountFetchAction extends Action {
    type: ActionTypes.FETCH_START;
}
export interface CheckoutsStripeAccountFetchSuccessAction extends Action {
    type: ActionTypes.FETCH_SUCCESS;
    payload: { checkoutsStripeAccount: CheckoutsAccountState };
}
export interface CheckoutsStripeAccountFetchErrorAction extends Action {
    type: ActionTypes.FETCH_ERROR;
}
export interface CheckoutsStripeAccountUpdateAction extends Action {
    type: ActionTypes.UPDATE_START;
    payload: { 
        ReturnUrl?: string,
        RefreshUrl?: string
    },
    meta: {
        thunk: true,
    },
}
export interface CheckoutsStripeAccountUpdateSuccessAction extends Action {
    type: ActionTypes.UPDATE_SUCCESS;
    payload: { 
        ReturnUrl: string,
        RefreshUrl?: string
    },
    meta: Record<string, unknown>;
}
export interface CheckoutsStripeAccountUpdateErrorAction extends Action {
    type: ActionTypes.UPDATE_ERROR;
    meta: Record<string, unknown>;
    error: boolean;
}

export interface CheckoutsAccountState {
    Email?: string;
    TosAcceptance?: boolean;
    ChargesEnabled?: boolean;
    refreshurl?: string;
    returnurl: string
}

export interface CheckoutsStripeAccountState {
    checkoutsStripeAccount: CheckoutsAccountState;
    isLoading: boolean,
    isLoaded: boolean,
    isError: boolean,
}
